var Times = 0;
var init = 0;
var plugin = true;

var clicked = false;
var langPrefix="";
var installdiv;
var isNoWebAccess=true;
function getParamVal(par)
{
	var params = window.priorityParams;
	var parInd = params.lastIndexOf(par);
    if (parInd >= 0)
        return Number(params[parInd + par.length]); 
    return NaN;
}
function isFromIcon() {
    return (window.priorityParams != null && getParamVal('_fromicon=') ==1);
}

function getCookie(cName) {
      const name = cName + "=";
      const cDecoded = decodeURIComponent(document.cookie); 
      const cArr = cDecoded .split('; ');
      let res;
      cArr.forEach(val => {
          if (val.indexOf(name) === 0) res = val.substring(name.length);
      })
      return res;
}

function instext() {
    clicked = true;
    if (!isNoWebAccess) {
        if (BrowserDetect.browser == "Firefox") {
            document.location = 'https://backoffice.eshbel.com/ffextension/priority_web.xpi';
        }
        else if (BrowserDetect.browser == "Edge") {
        	window.open('https://microsoftedge.microsoft.com/addons/detail/jejfmgocehpdigfpeegemdlijmlndhhp', '_blank');
        }
        else {
            var srch = window.location.search;
            var url = window.location.href;
            if (srch != null && srch.length > 0) {
                if (!isFromIcon())
                    url += "&_fromicon=1";
                url += "&_refresh=1";
            }
            else {
                url += "?_fromicon=1&_refresh=1";
            }
            var urlb64 = window.Base64.toBase64(unescape(encodeURIComponent(url)));
            var lang = "";
            if (basicLang == 0 || basicLang == 1)
                lang = "heb=1&";
            //document.location = 'https://backoffice.eshbel.com/inst.htm?' + lang + 'from=' + urlb64;
            //document.location = 'https://chrome.google.com/webstore/detail/kicgagenknliidcnkinbijjdfklmbmjb';
            window.open('https://chrome.google.com/webstore/detail/kicgagenknliidcnkinbijjdfklmbmjb', '_blank');
        }        
    }
    else {
        if (BrowserDetect.browser == "Firefox") {            
            if (document.location.href.includes("/h5/"))
                document.location = 'priority_web.xpi';
            else
                document.location = 'h5/priority_web.xpi';
        }
        else {
            var params = window.priorityParams;
            if (document.location.href.includes("/h5/"))
                document.location = 'plugin_inst.htm?' + params;
            else
                document.location = 'h5/plugin_inst.htm?' + params;
        }
    }
}

function img_loaded() {
	isNoWebAccess = false;
    if (clicked)
        instext();
}

function img_error() {
	isNoWebAccess = true;
    if (clicked)
        instext();
}
function insertInstallInfo()
{
	
	var bodyContent="";
	var basicind = window.location.href.lastIndexOf('_basiclang=');
	var basicLang = getCookie("Language") || 0;
    if (basicind >= 0)
        basicLang = Number(window.location.href[basicind+'_basiclang='.length]); //1=hebrew; 3=english
    if (basicLang == 0 || basicLang == 1) 
    {
        includeLinkFile("text/css", "stylesheet", baseUrl + "/css/default_heb.css");
        langPrefix = "Heb";
    } 
    else 
    {
        includeLinkFile("text/css", "stylesheet", baseUrl + "/css/default_eng.css");
        langPrefix = "Eng";
    }
    
    bodyContent = document.body.innerHTML;
    bodyContent += '\
    <font face="Arial" size="2">';

    if (basicLang == 0 || basicLang == 1) {
        bodyContent += installdiv_chromeHeb();
    } else {
        bodyContent += installdiv_chromeEng();
    }

    bodyContent += '</font>';
    $("body").html(bodyContent);
}

function loadInstallPage() {
    BrowserDetect.init();
    insertInstallInfo();
    
    if (BrowserDetect.browser == "Chrome" || BrowserDetect.browser == "Edge") {
        if (isFromIcon()) {
            installdiv = document.getElementById("postinstall_div_chrome" + langPrefix);
            installdiv.style.display = "block";
            document.body.style.backgroundColor = "white";
        }
        else {
            installdiv = document.getElementById("installdiv_chrome" + langPrefix);
            installdiv.style.display = "block";
            document.body.style.background = "#F1F7FC";
        }
    }
    else if (BrowserDetect.browser == "Firefox") {
        installdiv = document.getElementById("installdiv_chrome" + langPrefix);
        installdiv.style.display = "block";
        document.body.style.background = "#F1F7FC";
    }
    else {
        installdiv = document.getElementById("installdiv" + langPrefix);
        installdiv.style.display = "block";
        document.body.style.background = "#F1F7FC";
    }
}
function installPage_onload() {

    var ind = window.location.href.indexOf('_refresh=1');
    if (ind >= 0) {
        //Got here from Chrome extension installation page in backoffice.eshbel.com.
        //Do a reload in order for the extension to inject the content script to page.
        setTimeout(function () {
            window.location.replace(window.location.href.substr(0, ind - 1));
        }, 1000);
        return;
    }

    if (init == 0) {
        init = 1;
        BrowserDetect.init();
        var params = window.priorityParams;
         var disInd = params.lastIndexOf("_disableplugin=");
        var disVal = 0;
        if (disInd >= 0)
            disVal = Number(params[disInd + "_disableplugin=".length]);
        if (_isIpad() || _isAndroid() || _isMac() || disVal == 1) {         
            html5Onload();
            return;
        }
        
        if ((BrowserDetect.browser == "Chrome" || BrowserDetect.browser == "Firefox" || BrowserDetect.browser == "Edge") && getParamVal("_useOldPlugin=") != 1 /* && HasExtensionDiv() */) {
            plugin = false;
        }
    }
    if (!plugin) {
		if (!HasExtensionDiv()) {
            if (++Times <= 10) {
                setTimeout("installPage_onload()", 100);
                return;
            }
            //Avia - Don't try old plugin
            //else
		    //    plugin = true;

            //Try old plugin for Firefox new extension
            else if (BrowserDetect.browser == "Firefox") {
                plugin = true;
            }
        }
    }
    if (plugin) {
        var plg = document.createElement('object');
        plg.setAttribute('id', 'PriorityPlugin');
        plg.setAttribute('type', 'application/x-prih5');
        plg.setAttribute('width', '0');
        plg.setAttribute('height', '0');
        plg.style.position="absolute";
        document.body.appendChild(plg);
    }
    
     if (!HasPriorityVersion(plugin)) {
		if (++Times > 20) {
        	insertInstallInfo();
        	if (BrowserDetect.browser == "Chrome" || BrowserDetect.browser == "Edge") {
                if (isFromIcon()) {
                    installdiv = document.getElementById("postinstall_div_chrome" + langPrefix);
                    installdiv.style.display = "block";
                    document.body.style.backgroundColor = "white";
                }
                else {
                    installdiv = document.getElementById("installdiv_chrome" + langPrefix);
                    installdiv.style.display = "block";
                    document.body.style.background = "#F1F7FC";
                }
        	}
        	else if (BrowserDetect.browser == "Firefox") {
        	    installdiv = document.getElementById("installdiv_chrome" + langPrefix);
        	    installdiv.style.display = "block";
        	    document.body.style.background = "#F1F7FC";
        	}
            else {
                installdiv = document.getElementById("installdiv" + langPrefix);
                installdiv.style.display = "block";
                document.body.style.background = "#F1F7FC";
            }
        }
        else setTimeout("installPage_onload()", 100);
    }
    else {
        if (!checkBrowserVersion())
            return;
        else {
            html5Onload();
        }
    }
}

function englishInstallation() {

	var search=window.location.search;
	if(search!="")
		 document.location = window.location.href+"&_basiclang=3";
	else
		 document.location = window.location.href+"?_basiclang=3";

}

function installdiv_chromeEng() {
    var div = '<div id="installdiv_chromeEng" align="center" style="display:none">\
    <div class="border">\
        <div class="contentsEng">\
	        <div class="logoWrraper">\
                <img src="'+baseUrl+'/images/PriorityLogo.png">\
            </div>\
            <div class="contentContainer">\
                <p class="instTitle">Installation Instructions</p>\
                <ol>\
                    <li>\
                    Download the Priority Setup file <A href="'+baseUrl+'/install/prioritysetup.exe"\
                    onclick="javascript:document.cookie = \"Language=3; expires=Wed, 30-Dec-2037 12:00:00 GMT; path=\" +\
                    document.location.pathname.substring(0, document.location.pathname.lastIndexOf(\"/\") + 1) + "\h5/;\"; return(true)" class="link1">\
                    <span>here</span></A>, follow the instructions to install it, and proceed to the next step\
                     (even if you received a message that the file is already installed). \
                    </li>\
                    <li>After installation, you will see a message instructing you to install the Priority Web Extension.\
                    Follow the installation instructions. If the message does not appear, you can download the extension\
                    <a href="javascript:void()" onclick="instext(); return false;" class="link1">here</a>.\
                    </li>\
                    <li>Refresh the browser and reenter Priority. </li>\
                </ol>\
                <span class="instNote">Note: if you are still seeing this page after following the instructions above, restart your computer.</span>\
            </div>\
        </div>\
    </div>\
</div>';
    return div;
}

function installdiv_chromeHeb() {
    var div = '<div id="installdiv_chromeHeb" align="center" style="display:none">\
    <div class="border">\
    <div class="contentsHeb">\
    <div align="Left">\
      <div class="EnglishBut" onclick="englishInstallation();">\
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">\
			<path d="M12.5745 21C11.3358 21 10.1691 20.7633 9.07446 20.29C7.9798 19.8167 7.02646 19.1733 6.21446 18.36C5.40113 17.5487 4.7578 16.5953 4.28446 15.5C3.81113 14.4053 3.57446 13.2387 3.57446 12C3.57446 10.758 3.81113 9.59033 4.28446 8.497C4.75846 7.40367 5.4018 6.451 6.21446 5.639C7.0258 4.827 7.97913 4.18433 9.07446 3.711C10.1691 3.237 11.3358 3 12.5745 3C13.8165 3 14.9841 3.23667 16.0775 3.71C17.1708 4.184 18.1235 4.82733 18.9355 5.64C19.7475 6.452 20.3901 7.40433 20.8635 8.497C21.3375 9.59033 21.5745 10.758 21.5745 12C21.5745 13.2387 21.3378 14.4053 20.8645 15.5C20.3911 16.5947 19.7478 17.548 18.9345 18.36C18.1225 19.1727 17.1701 19.816 16.0775 20.29C14.9841 20.7633 13.8165 21 12.5745 21ZM12.5745 20.008C13.1611 19.254 13.6451 18.5137 14.0265 17.787C14.4071 17.0603 14.7168 16.247 14.9555 15.347H10.1935C10.4575 16.2977 10.7735 17.1363 11.1415 17.863C11.5095 18.5897 11.9871 19.3047 12.5745 20.008ZM11.3015 19.858C10.8348 19.308 10.4088 18.628 10.0235 17.818C9.63813 17.0087 9.35146 16.1847 9.16346 15.346H5.32746C5.9008 16.59 6.71313 17.61 7.76446 18.406C8.81646 19.202 9.99513 19.686 11.3005 19.858H11.3015ZM13.8475 19.858C15.1528 19.686 16.3315 19.202 17.3835 18.406C18.4355 17.61 19.2478 16.59 19.8205 15.346H15.9865C15.7331 16.1973 15.4141 17.028 15.0295 17.838C14.6441 18.6473 14.2501 19.3207 13.8475 19.858ZM4.92046 14.346H8.95546C8.87946 13.936 8.82613 13.5363 8.79546 13.147C8.76346 12.7577 8.74746 12.3753 8.74746 12C8.74746 11.6247 8.76313 11.2423 8.79446 10.853C8.8258 10.4637 8.87913 10.0637 8.95446 9.653H4.92146C4.8128 9.99967 4.7278 10.3773 4.66646 10.786C4.60513 11.1947 4.57446 11.5993 4.57446 12C4.57446 12.4013 4.6048 12.806 4.66546 13.214C4.7268 13.6227 4.8118 14 4.92046 14.346ZM9.95546 14.346H15.1935C15.2695 13.936 15.3228 13.5427 15.3535 13.166C15.3855 12.79 15.4015 12.4013 15.4015 12C15.4015 11.5987 15.3858 11.21 15.3545 10.834C15.3231 10.4573 15.2698 10.064 15.1945 9.654H9.95446C9.87913 10.064 9.8258 10.4573 9.79446 10.834C9.76313 11.21 9.74746 11.5987 9.74746 12C9.74746 12.4013 9.76313 12.79 9.79446 13.166C9.8258 13.5427 9.88013 13.936 9.95546 14.346ZM16.1935 14.346H20.2285C20.3371 13.9993 20.4221 13.622 20.4835 13.214C20.5448 12.806 20.5751 12.4013 20.5745 12C20.5745 11.5987 20.5441 11.194 20.4835 10.786C20.4221 10.3773 20.3371 10 20.2285 9.654H16.1935C16.2695 10.064 16.3228 10.4637 16.3535 10.853C16.3855 11.2423 16.4015 11.6247 16.4015 12C16.4015 12.3753 16.3858 12.7577 16.3545 13.147C16.3231 13.5363 16.2698 13.9363 16.1945 14.347L16.1935 14.346ZM15.9865 8.654H19.8205C19.2345 7.38467 18.4318 6.36467 17.4125 5.594C16.3925 4.82333 15.2041 4.33333 13.8475 4.124C14.3141 4.73733 14.7338 5.43933 15.1065 6.23C15.4785 7.02 15.7718 7.828 15.9865 8.654ZM10.1935 8.654H14.9555C14.6915 7.71533 14.3658 6.86667 13.9785 6.108C13.5918 5.34867 13.1238 4.64333 12.5745 3.992C12.0258 4.64333 11.5578 5.34867 11.1705 6.108C10.7838 6.86667 10.4581 7.71533 10.1935 8.654ZM5.32846 8.654H9.16246C9.37713 7.828 9.67046 7.02 10.0425 6.23C10.4151 5.43933 10.8348 4.737 11.3015 4.123C9.93213 4.333 8.7408 4.82633 7.72746 5.603C6.71413 6.38033 5.91413 7.397 5.32746 8.653L5.32846 8.654Z" fill="#16213D"/>\
		  </svg>\
          <span>English</span>\
      </div>\
    </div>\
	<div class="logoWrraper">\
      <img src="'+baseUrl+'/images/PriorityLogo.png">\
    </div>\
    <div class="contentContainer">\
      <p class="instTitle">הוראות התקנה</p>\
      <ol>\
        <li>הורידו את קובץ ההתקנה, <A href="'+baseUrl+'/install/prioritysetup.exe"\
        onclick="javascript:document.cookie = \'Language=1; expires=Wed, 30-Dec-2037 12:00:00 GMT; path=\' +\
        document.location.pathname.substring(0, document.location.pathname.lastIndexOf(\'/\') + 1) + \'h5/;\'; return(true)" class="link1">\
          <span>מכאן</span></A>. ועקבו אחר הוראות ההתקנה למחשב האישי.\
          עברו לשלב הבא גם אם קיבלתם הודעה שהקובץ כבר מותקן. </li> \
        <li>בסיום ההתקנה, תקפוץ בדפדפן הודעה להוספת Priority Web Extension לדפדפן. הוסיפו את ההרחבה. אם ההודעה לא הופיעה, הורידו את ההרחבה לדפדפן\
        <a href="javascript:void()" onclick="instext(); return false;" class="link1">מכאן</a> </li>\
        <li>רעננו את הדפדפן והיכנסו מחדש לפריוריטי. </li>\
      </ol>\
      <span class="instNote">הערה: אם לאחר השלמת כל הפעולות הגעתם שוב למסך זה, הפעילו מחדש את המחשב.</span>\
      </div>\
    <br>\
    </div>\
    </div>\
</div>';
    return div;
}
